import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ChevronDown, Menu, User as UserIcon, LogOut } from "lucide-react";
import { ApiMediaURL } from "../../setting/GlobleVariable";
import { LogoutUserFunc } from "../../redux/actions/User";

export default function AdminHeader({ setActive, setShowSidebar }) {
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const displayName =
    user?.firstName && user?.lastName
      ? `${user.firstName} ${user.lastName}`
      : user?.firstName || user?.email || "Admin";

  const initials =
    user?.firstName && user?.lastName
      ? `${user.firstName.slice(0, 1)}${user.lastName.slice(0, 1)}`.toUpperCase()
      : (user?.firstName?.slice(0, 2) || user?.email?.slice(0, 2) || "AD").toUpperCase();

  useEffect(() => {
    const onDocClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  return (
    <header
      className="h-[56px] bg-[#0B1120] border-b border-[#1a2744] flex items-center justify-between px-4 sm:px-8 sticky top-0 z-30"
      style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}
    >
      <div className="flex items-center gap-3 min-w-0">
        <button
          type="button"
          className="admin-header-menu text-white/70 hover:text-white lg:hidden shrink-0"
          onClick={() => setShowSidebar(true)}
          aria-label="Open menu"
        >
          <Menu className="w-5 h-5" strokeWidth={1.8} />
        </button>
        <h1
          className="text-white text-[16px] uppercase tracking-wider truncate"
          style={{ fontWeight: 700 }}
        >
          Admin Dashboard
        </h1>
      </div>

      <div className="relative flex items-center gap-3" ref={menuRef}>
        <span className="text-[13px] text-white/60 hidden sm:inline truncate max-w-[140px]">
          {displayName}
        </span>
        <button
          type="button"
          className="flex items-center gap-3 focus:outline-none"
          onClick={() => setMenuOpen((open) => !open)}
          aria-expanded={menuOpen}
          aria-haspopup="menu"
        >
          {user?.Avatar ? (
            <img
              src={`${ApiMediaURL}/${user.Avatar}`}
              alt=""
              className="w-8 h-8 rounded-full object-cover"
            />
          ) : (
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#E52324] to-[#ff6b6b] flex items-center justify-center">
              <span className="text-[9px] text-white" style={{ fontWeight: 700 }}>
                {initials}
              </span>
            </div>
          )}
          <ChevronDown className="w-3.5 h-3.5 text-white/30" />
        </button>

        {menuOpen && (
          <ul
            role="menu"
            className="absolute right-0 top-full mt-2 w-52 py-2 rounded-xl bg-[#0F172A] border border-[#1a2744] shadow-xl z-50"
          >
            <li>
              <button
                type="button"
                role="menuitem"
                className="w-full flex items-center justify-between gap-2 px-4 py-2.5 text-[13px] text-white/80 hover:bg-[#1a2744] hover:text-white transition-colors"
                onClick={() => {
                  setActive(3);
                  setMenuOpen(false);
                }}
              >
                Profile
                <UserIcon className="w-4 h-4 text-white/40" strokeWidth={1.8} />
              </button>
            </li>
            <li>
              <button
                type="button"
                role="menuitem"
                className="w-full flex items-center justify-between gap-2 px-4 py-2.5 text-[13px] text-white/80 hover:bg-[#1a2744] hover:text-white transition-colors"
                onClick={() => {
                  setMenuOpen(false);
                  dispatch(LogoutUserFunc(navigate));
                }}
              >
                Logout
                <LogOut className="w-4 h-4 text-white/40" strokeWidth={1.8} />
              </button>
            </li>
          </ul>
        )}
      </div>
    </header>
  );
}
